export default __webpack_public_path__ + "static/media/783fa627e0c07091be97fd2eed528fa7.png";